export const roleKey = {   // befinden sich auf Server in roles.db.
    Admin: "Admin",
    Benutzer: "Benutzer",
    Hauptbenutzer: "Hauptbenutzer",
    Gast: "Gast"
  }

 